import { createUseStyles } from 'react-jss'
import { MAX_CONTAINER_WIDTH } from 'src/config/styles'
import customColors from 'src/config/colorsV2'

export default createUseStyles({
  root: {
    minHeight: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: customColors.background,
    padding: [0, 16, 16, 16],
    '&$noPadding': {
      padding: 0,
    },
  },
  container: {
    width: '100%',
    maxWidth: MAX_CONTAINER_WIDTH,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    height: 'fit-content',
    '&$desktop': {
      justifyContent: 'center',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '24px',
    },
    '&$noGap': {
      gap: 0,
    },
  },
  desktop: {},
  noPadding: {},
  noGap: {},
})
